module.exports = __webpack_public_path__ + "static/img/App item-3.399b238.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/swiper2/App item-3.png
// module id = Q1U5
// module chunks = 12